import { TaleCircularProgress } from "@components/TaleCircularProgress";

export const TaleLoadingFallback = ({
  className = "",
  circleProps = {},
  ...props
}) => {
  return (
    <div
      className={`flex justify-center items-center w-full h-full ${
        className ?? ""
      }`}
      {...props}
    >
      <TaleCircularProgress thickness={4} {...circleProps} />
    </div>
  );
};
